import { useMemo } from 'react';
import { Social_Tag_Type_Enum } from '@kheops/graphql';
import { SocialTag } from '../../common/utils/social-tags.utils';

export interface DisplayRules {
  rules: { [ level: number ]: number };
  excluded?: Social_Tag_Type_Enum[];
  max?: number;
}

export default function useRelevantSocialTags<T extends SocialTag>(tags: T[], displayRules: DisplayRules): T[] {
  return useMemo((): T[] => {
    return tags.reduce((acc, tag) => {
      if (displayRules.rules[tag.level] && !displayRules.excluded?.includes(tag.type)) {
        if (!acc[tag.level]) {
          acc[tag.level] = [tag];
        } else {
          // splice() is called twice to handle any order of tags received as argument
          acc[tag.level].splice(tag.priority - 1, 0, tag);
          acc[tag.level].splice(displayRules.rules[tag.level], acc[tag.level].length);
        }
      }

      return acc;
    }, [] as T[][]).flat();
  }, [tags, displayRules]).slice(0, displayRules.max);
}
